import { ERentioFormField } from "../../components/components/Form";
import { getName } from "../../redux/contact/contact.utils";
import { getValue } from "../../redux/form/form.utils";
import { EContractMemberTypes } from "../../types/contract.types";
import { EDocumentCategory } from "../../types/document.types";
import { ERentDepositProvider } from "../../types/rentDeposit.types";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { formatCurrency, subtractWithDecimalPrecision, } from "../../utils/number.utils";
import { EField } from "./schema.releaseRentDeposit.types";
import { getNavigationTitle } from "./schema.releaseRentDeposit.utils";
export var getSchema = function (initialValues, _a) {
    var relatedContract = _a.relatedContract, rentDeposit = _a.rentDeposit;
    return function (defaultValues) {
        var _a;
        return ({
            required: [EField.TenantAmount],
            properties: (_a = {},
                _a[EField.Header + "1"] = {
                    default: undefined,
                },
                _a[EField.BanqupInfo] = {
                    default: undefined,
                    // @ts-ignore
                    showIf: function () { return (rentDeposit === null || rentDeposit === void 0 ? void 0 : rentDeposit.provider) !== ERentDepositProvider.MangoPay; },
                },
                _a[EField.Info] = {
                    default: undefined,
                },
                _a[EField.TenantAmount] = {
                    default: getValue(EField.TenantAmount, initialValues, defaultValues),
                    minimum: 0,
                    maximum: relatedContract.amount,
                },
                _a[EField.OwnerAmount] = {
                    default: getValue(EField.OwnerAmount, initialValues, defaultValues),
                    minimum: 0,
                    maximum: relatedContract.amount,
                    // @ts-ignore
                    handleChange: function (fieldName, fieldValue, _, formData) {
                        if (fieldValue === void 0) { fieldValue = 0; }
                        if (fieldName === EField.TenantAmount) {
                            var newOwnerAmount = Math.max(0, subtractWithDecimalPrecision(relatedContract.amount || 0, fieldValue));
                            return { shouldSetNewValue: true, newValue: newOwnerAmount };
                        }
                        if (fieldName === EField.BrokerAmount) {
                            var tenantAmount = formData[EField.TenantAmount];
                            var newOwnerAmount = Math.max(0, subtractWithDecimalPrecision(relatedContract.amount || 0, tenantAmount + fieldValue));
                            return { shouldSetNewValue: true, newValue: newOwnerAmount };
                        }
                        return { shouldSetNewValue: false };
                    },
                },
                _a[EField.BrokerAmount] = {
                    default: getValue(EField.BrokerAmount, initialValues, defaultValues),
                    minimum: 0,
                    maximum: relatedContract.amount,
                    // @ts-ignore
                    handleChange: function (fieldName, fieldValue, _, formData) {
                        if (fieldValue === void 0) { fieldValue = 0; }
                        if (fieldName === EField.OwnerAmount ||
                            fieldName === EField.TenantAmount) {
                            var tenantAmount = fieldName === EField.TenantAmount
                                ? fieldValue
                                : formData[EField.TenantAmount];
                            var ownerAmount = fieldName === EField.OwnerAmount
                                ? fieldValue
                                : formData[EField.OwnerAmount];
                            var newBrokerAmount = Math.max(0, subtractWithDecimalPrecision(relatedContract.amount || 0, tenantAmount + ownerAmount));
                            return { shouldSetNewValue: true, newValue: newBrokerAmount };
                        }
                        return { shouldSetNewValue: false };
                    },
                },
                _a[EField.LeaseContractDocument] = {
                    default: getValue(EField.LeaseContractDocument, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (formData) {
                        return (rentDeposit === null || rentDeposit === void 0 ? void 0 : rentDeposit.provider) !== ERentDepositProvider.MangoPay;
                    },
                    requiredIf: function (formData) {
                        return (rentDeposit === null || rentDeposit === void 0 ? void 0 : rentDeposit.provider) !== ERentDepositProvider.MangoPay;
                    },
                },
                _a[EField.JudicialRelease] = {
                    type: "boolean",
                    default: getValue(EField.JudicialRelease, initialValues, defaultValues),
                },
                _a[EField.VerdictPdf] = {
                    default: getValue(EField.VerdictPdf, initialValues, defaultValues),
                    // @ts-ignore
                    showIf: function (formData) { return formData[EField.JudicialRelease]; },
                    requiredIf: function (formData) { return formData[EField.JudicialRelease]; },
                },
                _a),
        });
    };
};
export var uiSchema = function (extraData) {
    var _a;
    var tenants = extraData.relatedContract.members.filter(function (member) {
        return member.roles.includes(EContractMemberTypes.Tenant) ||
            member.roles.includes(EContractMemberTypes.Parent);
    });
    var owners = extraData.relatedContract.members.filter(function (member) {
        return member.roles.includes(EContractMemberTypes.Owner);
    });
    return _a = {
            "rentio:title": getLocalizedText("rent_deposit_release.split.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "1"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit_release.split.heading"),
        },
        _a[EField.BanqupInfo] = {
            "ui:field": ERentioFormField.HelpInfo,
            title: getLocalizedText("rent_deposit_release_via_banqup.contract_info.heading"),
            type: "warning",
            actionTitle: getLocalizedText("system.more_info"),
            onPressAction: function () {
                return window.open(getLocalizedText("rent_deposit_release_via_banqup.contract_info.url"));
            },
            subtitle: getLocalizedText("rent_deposit_release_via_banqup.contract_info.content"),
        },
        _a[EField.Info] = {
            "ui:field": ERentioFormField.HelpInfo,
            title: getLocalizedText("rent_deposit_release.contract_info.heading"),
            subtitle: (function () {
                return getLocalizedText("rent_deposit_release.contract_info.content", {
                    startDate: formatDate(extraData.relatedContract.startDate),
                    amount: formatCurrency(extraData.relatedContract.amount),
                    tenants: tenants.map(function (member) { return getName(member.account); }).join(", "),
                    owners: owners.map(function (member) { return getName(member.account); }).join(", "),
                });
            })(),
        },
        _a[EField.TenantAmount] = {
            "ui:field": ERentioFormField.Number,
            formatSummary: function (formData) {
                return formData && formatCurrency(formData);
            },
            title: getLocalizedText("rent_deposit_release.tenant_amount.label"),
            suffixText: "EUR",
            isFloat: true,
        },
        _a[EField.OwnerAmount] = {
            "ui:field": ERentioFormField.Number,
            formatSummary: function (formData) {
                return formData ? formatCurrency(formData) : undefined;
            },
            placeholder: "0",
            title: getLocalizedText("rent_deposit_release.owner_amount.label"),
            suffixText: "EUR",
            isFloat: true,
        },
        _a[EField.BrokerAmount] = {
            "ui:field": ERentioFormField.Number,
            formatSummary: function (formData) {
                return formData && formatCurrency(formData);
            },
            placeholder: "0",
            title: getLocalizedText("rent_deposit_release.broker_amount.label"),
            suffixText: "EUR",
            isFloat: true,
        },
        _a[EField.LeaseContractDocument] = {
            "ui:field": ERentioFormField.DocumentSelectInline,
            accept: ["application/pdf"],
            mimeTypes: ["application/pdf"],
            multiple: false,
            useExistingDocuments: true,
            showOptionsOnFirstFocus: true,
            minFileSize: 32000, // 32KB
            maxFileSize: 25000000, // 10MB
            getExistingDocumentsWhereFilter: function () {
                var _a;
                return ({
                    propertyId: { eq: (_a = extraData.rentDeposit) === null || _a === void 0 ? void 0 : _a.propertyId },
                    categoryId: { eq: EDocumentCategory.Contract },
                });
            },
            title: getLocalizedText("property.dashboard.checklist.template_document_contract.heading"),
            valueSelector: function (state, formData) {
                var _a, _b;
                if (formData === void 0) { formData = []; }
                if (typeof formData === "string") {
                    var document_1 = (_a = state.DOCUMENTS_V2.detail[formData]) === null || _a === void 0 ? void 0 : _a.entity;
                    if (document_1) {
                        return document_1.filename;
                    }
                    return getLocalizedText("summary.view.document");
                }
                return (_b = formData[0]) === null || _b === void 0 ? void 0 : _b.name;
            },
        },
        _a[EField.JudicialRelease] = {
            "ui:field": ERentioFormField.Switch,
            title: getLocalizedText("rent_deposit_release.release_type"),
            label: getLocalizedText("rent_deposit_release.via_judgement.label"),
            formatSummary: function (formData) {
                if (formData) {
                    return getLocalizedText("rent_deposit_release.via_judgement.label");
                }
            },
        },
        _a[EField.VerdictPdf] = {
            "ui:field": ERentioFormField.DocumentSelectInline,
            title: getLocalizedText("rent_deposit_release.verdictPdf.label"),
            info: getLocalizedText("rent_deposit_release.verdictPdf.info"),
            accept: ["application/pdf"],
            mimeTypes: ["application/pdf"],
            multiple: false,
            valueSelector: function (state, formData) {
                if (formData === void 0) { formData = []; }
                return (formData || [])
                    .map(function (item) {
                    var _a;
                    if (typeof item === "string") {
                        var document_2 = (_a = state.DOCUMENTS_V2.detail[item]) === null || _a === void 0 ? void 0 : _a.entity;
                        if (document_2) {
                            return document_2.filename;
                        }
                        return getLocalizedText("summary.view.document");
                    }
                    return item.name;
                })
                    .join(", ");
            },
        },
        _a;
};
export var getValidate = function (extraData) { return function (formData, errors) {
    if (formData[EField.OwnerAmount] +
        formData[EField.TenantAmount] +
        formData[EField.BrokerAmount] !==
        extraData.relatedContract.amount) {
        var amountError = getLocalizedText("rent_deposit_release.sum_amounts.error", {
            amount: formatCurrency(extraData.relatedContract.amount),
        });
        errors[EField.OwnerAmount].addError(amountError);
        errors[EField.TenantAmount].addError(amountError);
        errors[EField.BrokerAmount].addError(amountError);
    }
    return errors;
}; };
